<template>
  <div>
    <SelectAndTransferHozehGazayiProvince
      type="province"
      :status="3"
      limitCountKey="province_transfer_count"
      messageKey="province_transfer_description"
      getKey="hozeh_ghazayi_province"
      postKey="hozeh_ghazayi_province_id"
      :showCancelAlert="true"
      :forceHasHozehSelect="true"
      :headerAlertText="headerAlertText"
      titleIcon="fa fa-map-signs"
      titleText="انتقال حوزه استانی"
      @updateRegistered="updateRegistered"
      @updateAlertMessage="updateAlertMessage"
      @updateCurrentProvince="updateCurrentProvince"
    />
  </div>
</template>
<script>
import SelectAndTransferHozehGazayiProvince from "./components/SelectAndTransferHozehGazayiProvince";
import { pathOr } from "ramda";

export default {
  name: "transferHozeHgazayiProvince",
  components: {
    SelectAndTransferHozehGazayiProvince,
  },
  data() {
    return {
      currentProvince: {},
      registered: false,
      alertMessage: "",
    };
  },
  computed: {
    headerAlertText() {
      const firstText = `
        <i class="fas fa-check-circle fa-lg mr-2 text-success"></i>
        <span class="text-success">باتوجه به تایید انتخاب حوزه توسط شما فقط حوزه‌های انتخابی برای شما قابل نمایش است و امکان تغییر آن را ندارید.</span>
      `;
      const secondText = `
        <i class="fas fa-info-circle fa-lg mr-1 text-danger"></i>
        <span class="text-danger"> دقت کنید که این انتخاب پس از نهایی سازی قابل تغییر نمی‌باشد.</span>
      `;
      const text = this.registered ? firstText : secondText;

      return `${this.alertMessage}<br />${text}`;
    },
  },
  methods: {
    pathOr,
    updateRegistered(value) {
      this.registered = value;
    },
    updateAlertMessage(value) {
      this.alertMessage = value;
    },
    updateCurrentProvince(value) {
      this.currentProvince = value;
    },
  },
};
</script>